import { render, staticRenderFns } from "./politicasPrivacidadCliente.vue?vue&type=template&id=e0ccca7a&scoped=true&"
import script from "./politicasPrivacidadCliente.vue?vue&type=script&lang=js&"
export * from "./politicasPrivacidadCliente.vue?vue&type=script&lang=js&"
import style0 from "./politicasPrivacidadCliente.vue?vue&type=style&index=0&id=e0ccca7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ccca7a",
  null
  
)

export default component.exports